import { render, staticRenderFns } from "./achievement-info.vue?vue&type=template&id=06555506&scoped=true"
import script from "./achievement-info.vue?vue&type=script&lang=js"
export * from "./achievement-info.vue?vue&type=script&lang=js"
import style0 from "./achievement-info.vue?vue&type=style&index=0&id=06555506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06555506",
  null
  
)

export default component.exports